var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"checkbox-field"},[_c('div',{staticClass:"form-field form-checkbox"},[_c('q-checkbox',{attrs:{"dark":"","value":_setup.value,"label":_vm.label},on:{"input":_setup.changeValue}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }